const getRowUserId = elementId =>
  elementId.slice(elementId.lastIndexOf('-') + 1);

export default getRowUserId;
